"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const Preferences_1 = __importDefault(require("chaire-lib-common/lib/config/Preferences"));
const application_config_1 = __importDefault(require("../../../config/application.config"));
const project_config_1 = __importDefault(require("evolution-common/lib/config/project.config"));
const LoadingPage_1 = __importDefault(require("chaire-lib-frontend/lib/components/pages/LoadingPage"));
const SurveyAdmin_1 = require("../../../actions/SurveyAdmin");
const ReviewCommentForm_1 = __importDefault(require("./ReviewCommentForm"));
const AdminErrorBoundary_1 = __importDefault(require("../hoc/AdminErrorBoundary"));
const odSurveyAdminHelper_1 = require("../../../services/admin/odSurveyAdminHelper");
/** Max wait for `surveyObjectsAndAudits` before showing the unavailable fallback. */
const SURVEY_OBJECTS_LOAD_TIMEOUT_MS = 30000;
const ValidationOnePageSummary = () => {
    const { t } = (0, react_i18next_1.useTranslation)(['admin']);
    // We need two separate place paths because of deduplication:
    // - activeMapPlacePath: Controls which icon is enlarged on the map (uses representative path for deduplicated places)
    // - activeStatsPlacePath: Controls which visited place is highlighted in stats (uses the actual clicked path)
    // This allows clicking on any duplicate visited place to highlight that specific entry in stats
    // while still properly activating the single deduplicated icon on the map
    const [activeMapPlacePath, setActiveMapPlacePath] = react_1.default.useState(undefined);
    const [activeStatsPlacePath, setActiveStatsPlacePath] = react_1.default.useState(undefined);
    const [activeTripUuid, setActiveTripUuid] = react_1.default.useState(undefined);
    const [shouldZoomToPlace, setShouldZoomToPlace] = react_1.default.useState(false);
    // Debug wrapper for setActiveTripUuid with unselect behavior
    const toggleActiveTripUuid = (tripUuid) => {
        // If clicking on already selected trip, deselect it
        if (activeTripUuid === tripUuid) {
            setActiveTripUuid(undefined);
            return;
        }
        setActiveTripUuid(tripUuid);
    };
    const [InterviewStats, setInterviewStats] = (0, react_1.useState)(null);
    const [InterviewMap, setInterviewMap] = (0, react_1.useState)(null);
    const [showAuditErrorCode, setShowAuditErrorCode] = (0, react_1.useState)(false);
    const [surveyObjectsLoadTimedOut, setSurveyObjectsLoadTimedOut] = (0, react_1.useState)(false);
    // FIXME Admin interview type should be different from participant, with more types
    const interview = (0, react_redux_1.useSelector)((state) => state.survey.interview);
    const user = (0, react_redux_1.useSelector)((state) => state.auth.user);
    // FIXME Add the validationDataDirty to the interview type, but it is only for the admin
    const validationDataDirty = interview === null || interview === void 0 ? void 0 : interview.validationDataDirty;
    const dispatch = (0, react_redux_1.useDispatch)();
    const startUpdateInterview = (data, callback) => dispatch((0, SurveyAdmin_1.startUpdateSurveyCorrectedInterview)(data, callback));
    (0, react_1.useEffect)(() => {
        const loadComponents = () => __awaiter(void 0, void 0, void 0, function* () {
            const InterviewStatsComponent = application_config_1.default.getCustomInterviewStat()
                ? yield application_config_1.default.getCustomInterviewStat()
                : (yield Promise.resolve().then(() => __importStar(require('./InterviewStats')))).default;
            setInterviewStats(() => InterviewStatsComponent);
            const InterviewMapComponent = application_config_1.default.getCustomInterviewMap()
                ? yield application_config_1.default.getCustomInterviewMap()
                : (yield Promise.resolve().then(() => __importStar(require('./InterviewMap')))).default;
            setInterviewMap(() => InterviewMapComponent);
        });
        loadComponents();
    }, []);
    // The audited survey objects arrive with the interview fetch and may never show up if
    // that request fails or returns without them. Instead of showing the loading spinner
    // forever, flag the load as timed out after SURVEY_OBJECTS_LOAD_TIMEOUT_MS so the UI
    // can display an explicit error message. The flag is reset whenever the interview
    // changes or the objects finally arrive.
    (0, react_1.useEffect)(() => {
        setSurveyObjectsLoadTimedOut(false);
        if (interview === null || interview === void 0 ? void 0 : interview.surveyObjectsAndAudits) {
            return undefined;
        }
        const timeoutId = window.setTimeout(() => setSurveyObjectsLoadTimedOut(true), SURVEY_OBJECTS_LOAD_TIMEOUT_MS);
        return () => window.clearTimeout(timeoutId);
    }, [interview === null || interview === void 0 ? void 0 : interview.uuid, interview === null || interview === void 0 ? void 0 : interview.surveyObjectsAndAudits]);
    // Load preferences and set up preference change listener
    (0, react_1.useEffect)(() => {
        const loadPreferences = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                yield Preferences_1.default.load();
                setShowAuditErrorCode(Preferences_1.default.get('admin.interviewStats.showAuditErrorCode', false));
            }
            catch (e) {
                console.error('Failed to load preferences', e);
            }
        });
        loadPreferences();
        // Set up preference change listener
        const preferenceChangeHandler = (changedPrefs) => {
            if (changedPrefs['admin.interviewStats.showAuditErrorCode'] !== undefined) {
                setShowAuditErrorCode(changedPrefs['admin.interviewStats.showAuditErrorCode']);
            }
        };
        Preferences_1.default.addChangeListener(preferenceChangeHandler);
        return () => {
            Preferences_1.default.removeChangeListener(preferenceChangeHandler);
        };
    }, []);
    const toggleAuditErrorCode = () => __awaiter(void 0, void 0, void 0, function* () {
        const prev = showAuditErrorCode;
        const newValue = !showAuditErrorCode;
        setShowAuditErrorCode(newValue);
        try {
            yield Preferences_1.default.update({ 'admin.interviewStats.showAuditErrorCode': newValue });
        }
        catch (e) {
            console.error('Failed to update preferences', e);
            setShowAuditErrorCode(prev);
        }
    });
    // Generate map features with current selection state - regenerate when selection changes
    const { placesCollection, tripsCollection, pathToUniqueKeyMap } = react_1.default.useMemo(() => {
        if (!interview)
            return {
                placesCollection: { type: 'FeatureCollection', features: [] },
                tripsCollection: { type: 'FeatureCollection', features: [] },
                pathToUniqueKeyMap: new Map()
            };
        if (application_config_1.default.generateMapFeatures) {
            // Custom map generators require surveyObjectsAndAudits (sync admin deploy).
            // Falls back to generateMapFeatureFromInterview when the payload is not loaded yet or generation fails.
            const surveyObjects = interview.surveyObjectsAndAudits;
            if (surveyObjects) {
                try {
                    const result = application_config_1.default.generateMapFeatures(surveyObjects);
                    return Object.assign(Object.assign({}, result), { pathToUniqueKeyMap: new Map() }); // Custom generators don't have mapping yet
                }
                catch (error) {
                    console.error('Custom map generation failed, falling back to default generator:', error);
                }
            }
        }
        const result = (0, odSurveyAdminHelper_1.generateMapFeatureFromInterview)(interview, {
            activePlacePath: activeMapPlacePath,
            activeTripUuid
        });
        return result;
    }, [interview, activeMapPlacePath, activeTripUuid, interview === null || interview === void 0 ? void 0 : interview.updateCount]);
    // Smart place selection function that maps visited place paths to unique icons
    const selectPlaceWithMapping = react_1.default.useCallback((placePath, shouldZoom = false) => {
        if (!placePath) {
            setActiveMapPlacePath(undefined);
            setActiveStatsPlacePath(undefined);
            setShouldZoomToPlace(false);
            return;
        }
        // Check if clicking on already selected place - if so, deselect
        if (activeStatsPlacePath === placePath) {
            setActiveMapPlacePath(undefined);
            setActiveStatsPlacePath(undefined);
            setShouldZoomToPlace(false);
            return;
        }
        // Also check if clicking on a place that maps to the same unique key as currently selected
        const clickedUniqueKey = pathToUniqueKeyMap.get(placePath);
        const currentUniqueKey = activeStatsPlacePath ? pathToUniqueKeyMap.get(activeStatsPlacePath) : undefined;
        if (clickedUniqueKey && currentUniqueKey && clickedUniqueKey === currentUniqueKey) {
            setActiveMapPlacePath(undefined);
            setActiveStatsPlacePath(undefined);
            setShouldZoomToPlace(false);
            return;
        }
        // Always set the clicked path for stats display
        setActiveStatsPlacePath(placePath);
        setShouldZoomToPlace(shouldZoom);
        // Try to find the unique key for this path
        // We select the first path from the non unique location/activity and set it to active.
        // The placePath is the path to the visited place in the interview response. Like
        // `household.persons.123.journeys.456.visitedPlaces.789` or `home`
        const uniqueKey = pathToUniqueKeyMap.get(placePath);
        if (uniqueKey) {
            // Find the first path that maps to this unique key (the representative path for the icon)
            for (const [path, key] of pathToUniqueKeyMap) {
                if (key === uniqueKey) {
                    setActiveMapPlacePath(path);
                    return;
                }
            }
        }
        // Fallback: use the original path if no mapping found
        setActiveMapPlacePath(placePath);
    }, [pathToUniqueKeyMap, activeStatsPlacePath]);
    // Place selection from map (no auto-zoom)
    const selectPlaceFromMap = react_1.default.useCallback((placePath) => {
        selectPlaceWithMapping(placePath, false);
    }, [selectPlaceWithMapping]);
    // Place selection from stats (with auto-zoom)
    const selectPlaceFromStats = react_1.default.useCallback((placePath) => {
        selectPlaceWithMapping(placePath, true);
    }, [selectPlaceWithMapping]);
    /**
     * Handle place drag to update coordinates in interview data using valuesByPath
     */
    const handlePlaceDrag = react_1.default.useCallback((placePath, newCoordinates) => {
        var _a;
        try {
            // Find the visited place to determine its activity type
            const visitedPlace = placesCollection.features.find((feature) => { var _a; return ((_a = feature.properties) === null || _a === void 0 ? void 0 : _a.path) === placePath; });
            const activity = (_a = visitedPlace === null || visitedPlace === void 0 ? void 0 : visitedPlace.properties) === null || _a === void 0 ? void 0 : _a.activity;
            let updatePath;
            if (activity === 'home') {
                // Home places: update response.home.geography.geometry.coordinates
                updatePath = 'response.home.geography.geometry.coordinates';
            }
            else if (activity === 'workUsual') {
                // Usual work places: update person.usualWorkPlace.geography.geometry.coordinates
                const pathParts = placePath.split('.');
                const personUuid = pathParts[3];
                updatePath = `response.household.persons.${personUuid}.usualWorkPlace.geography.geometry.coordinates`;
            }
            else if (activity === 'schoolUsual') {
                // Usual school places: update person.usualSchoolPlace.geography.geometry.coordinates
                const pathParts = placePath.split('.');
                const personUuid = pathParts[3];
                updatePath = `response.household.persons.${personUuid}.usualSchoolPlace.geography.geometry.coordinates`;
            }
            else {
                // Regular visited places: update visitedPlace.geography.geometry.coordinates
                updatePath = placePath + '.geography.geometry.coordinates';
            }
            // Update using valuesByPath - only update coordinates to preserve other properties
            startUpdateInterview({
                valuesByPath: {
                    [updatePath]: newCoordinates
                }
            }, (interview) => {
                if (!interview) {
                    console.error('❌ Failed to update place coordinates');
                }
            });
        }
        catch (error) {
            console.error('❌ Error updating place coordinates:', error);
        }
    }, [startUpdateInterview, placesCollection]);
    if (!InterviewStats || !InterviewMap || !user) {
        return react_1.default.createElement(LoadingPage_1.default, null);
    }
    if (!(interview === null || interview === void 0 ? void 0 : interview.surveyObjectsAndAudits)) {
        if (surveyObjectsLoadTimedOut) {
            return (react_1.default.createElement("div", { className: "survey validation" },
                react_1.default.createElement("div", { className: "admin__interview-stats" },
                    react_1.default.createElement("h4", null, t('interviewStats.errors.error')),
                    react_1.default.createElement("p", { className: "_red" }, t('interviewStats.errors.surveyObjectsLoadTimedOut')))));
        }
        return react_1.default.createElement(LoadingPage_1.default, null);
    }
    const mapCenter = placesCollection.features.length > 0
        ? placesCollection.features[0].geometry.coordinates
        : [project_config_1.default.mapDefaultCenter.lon, project_config_1.default.mapDefaultCenter.lat];
    return (react_1.default.createElement("div", { className: "survey validation" },
        react_1.default.createElement("div", { style: { width: '100%', margin: '0 auto' } },
            react_1.default.createElement("div", { className: "admin__interview-map-and-stats-container" },
                react_1.default.createElement("div", { className: "admin__interview-map-container" },
                    react_1.default.createElement(AdminErrorBoundary_1.default, null,
                        react_1.default.createElement(InterviewMap, { places: placesCollection, trips: tripsCollection, center: mapCenter, updateCount: interview.updateCount, activeTripUuid: activeTripUuid, activePlacePath: activeMapPlacePath, shouldZoomToPlace: shouldZoomToPlace, onTripClick: toggleActiveTripUuid, onPlaceClick: selectPlaceFromMap, onPlaceDrag: handlePlaceDrag }))),
                react_1.default.createElement("div", { className: "admin__stats-container" },
                    react_1.default.createElement(AdminErrorBoundary_1.default, null,
                        react_1.default.createElement(InterviewStats, { selectPlace: selectPlaceFromStats, selectTrip: toggleActiveTripUuid, activeTripUuid: activeTripUuid, interview: interview, surveyObjectsAndAudits: interview.surveyObjectsAndAudits, activePlacePath: activeStatsPlacePath, user: user, startUpdateInterview: startUpdateInterview, prefs: { showAuditErrorCode }, toggleAuditErrorCode: toggleAuditErrorCode, validationDataDirty: validationDataDirty })),
                    react_1.default.createElement(ReviewCommentForm_1.default, { interview: interview }))))));
};
exports.default = ValidationOnePageSummary;
//# sourceMappingURL=ValidationOnePageSummary.js.map